import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { AdCampaignsPage } from './pages/AdCampaignsPage';
import { AutomationsPage } from './pages/AutomationsPage';
import { CustomAutomationsPage } from './pages/CustomAutomationsPage';
import { WebDesignSeoPage } from './pages/WebDesignSeoPage';
import { PricingPage } from './pages/PricingPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { RobotsTxt } from './pages/RobotsTxt';
import { SitemapXml } from './pages/SitemapXml';
import { CaseStudiesPage } from './pages/CaseStudiesPage';
import { TfpLandscapingPage } from './pages/CaseStudies/TfpLandscapingPage';
import { FinishCoatPaintingPage } from './pages/CaseStudies/FinishCoatPaintingPage';
import { GbpSetupPage } from './pages/GbpSetupPage';
import { GmailSignatureGeneratorPage } from './pages/tools/GmailSignatureGeneratorPage';
import { CrmBusinessToolsPage } from './pages/CrmBusinessToolsPage';
import { ReputationManagementPage } from './pages/ReputationManagementPage';
import { BlogPage } from './pages/BlogPage';
import { HowToChooseMarketingAgency } from './pages/blog/HowToChooseMarketingAgency';
import { WhyResponseTimeMakesOrBreaksYourYelpAds } from './pages/blog/WhyResponseTimeMakesOrBreaksYourYelpAds';
import { FasterYelpRepliesMoreLandscapingEstimates } from './pages/blog/FasterYelpRepliesMoreLandscapingEstimates';
import { AiReceptionistVsHumanReceptionistCost } from './pages/blog/AiReceptionistVsHumanReceptionistCost';
import { MissedCallTextBack } from './pages/blog/MissedCallTextBack';
function SiteLayout() {
  return <div className="flex flex-col min-h-screen bg-viridia-black font-sans text-white" data-id="element-0" data-mp="36hx792iaw2a">
      <Navbar data-id="element-1" data-mp="38b4mqky1kbc" />
      <noscript data-id="element-2" data-mp="3uct0zcywiaxb">
        <div style={{
        padding: '2rem',
        maxWidth: '800px',
        margin: '0 auto'
      }} data-id="element-3" data-mp="3udazkg91d18e">
          <h1 data-id="element-4" data-mp="d3wc348s7csh">
            Viridia Analytics - Phoenix Marketing Agency for Local Service
            Businesses
          </h1>
          <p data-id="element-5" data-mp="3gle9ehqxh1en">
            We help local service businesses stop missing leads, respond
            instantly, and book more jobs. Real systems, real results from real
            Phoenix-area clients.
          </p>
          <h2 data-id="element-6" data-mp="3qbpo8zc5gv0b">Our Services</h2>
          <ul data-id="element-7" data-mp="3qbzgktko3e96">
            <li data-id="element-8" data-mp="3qcr2tdsdjzms">
              <a href="/ai-lead-conversion" data-id="element-9" data-mp="3qdag2h72xzuh">
                AI Lead Conversion - Follow-Up, AI Receptionist, Lead Nurturing
              </a>
            </li>
            <li data-id="element-10" data-mp="2xtv94ioag1gb">
              <a href="/custom-automations" data-id="element-11" data-mp="2xtbzrqcpeldw">
                Custom Automations - Tailored Workflows, API Integrations
              </a>
            </li>
            <li data-id="element-12" data-mp="18d9e69sxtqtr">
              <a href="/crm-business-tools" data-id="element-13" data-mp="18cq75o4tsmui">
                CRM &amp; Business Tools - Centralized Hub, Invoicing, Pipeline
              </a>
            </li>
            <li data-id="element-14" data-mp="yfli9gjlida0">
              <a href="/reputation-management" data-id="element-15" data-mp="yfv6ayl2yad2">
                Reputation Management - Automated Reviews, Trust Building
              </a>
            </li>
            <li data-id="element-16" data-mp="13ey35vqwpa9y">
              <a href="/ad-campaigns" data-id="element-17" data-mp="13cbvzx7xgws9">
                Ad Campaign Management - Google Ads, Meta Ads, and local lead
                platforms
              </a>
            </li>
            <li data-id="element-18" data-mp="1w2kig19hy3cn">
              <a href="/web-design-seo" data-id="element-19" data-mp="1w0zoodv0aofu">Web Design &amp; Local SEO</a>
            </li>
          </ul>
          <h2 data-id="element-20" data-mp="1i5x88wsj9gos">Contact Us</h2>
          <p data-id="element-21" data-mp="1m4mulevju8kk">
            Phone: <a href="tel:6233000708" data-id="element-22" data-mp="1m44sw2q4b259">(623) 300-0708</a>
          </p>
          <p data-id="element-23" data-mp="6onp6bdbgqo0">
            Email:{' '}
            <a href="mailto:info@viridiaanalytics.com" data-id="element-24" data-mp="6nmggdjrwg9g">
              info@viridiaanalytics.com
            </a>
          </p>
          <p data-id="element-25" data-mp="anwjpig6kskm">Location: Phoenix, AZ - Serving Local Businesses</p>
          <h2 data-id="element-26" data-mp="qy71wwt8at6g">Quick Links</h2>
          <ul data-id="element-27" data-mp="qygmu5zf2a5a">
            <li data-id="element-28" data-mp="qyyqvosblsnr">
              <a href="/about" data-id="element-29" data-mp="m6p1qaz14wmj">About Us</a>
            </li>
            <li data-id="element-30" data-mp="m549wt43nrsd">
              <a href="/case-studies" data-id="element-31" data-mp="m4m3j3nq3x6q">Case Studies</a>
            </li>
            <li data-id="element-32" data-mp="h7vmoe43gxk9">
              <a href="/pricing" data-id="element-33" data-mp="h59hum8l8w5q">Pricing</a>
            </li>
            <li data-id="element-34" data-mp="c9alabd3w7u8">
              <a href="/contact" data-id="element-35" data-mp="c9u5jyq8b8bf">Book a Free Strategy Call</a>
            </li>
            <li data-id="element-36" data-mp="19uyj90p7my7v">
              <a href="/privacy" data-id="element-37" data-mp="19vhq9mdbo274">Privacy Policy</a>
            </li>
            <li data-id="element-38" data-mp="14wetsqber4ar">
              <a href="/terms" data-id="element-39" data-mp="14xyagi0z7hd2">Terms of Service</a>
            </li>
          </ul>
        </div>
      </noscript>
      <main role="main" className="flex-grow" data-id="element-40" data-mp="zwiv96lhc52l">
        <Routes data-id="element-41" data-mp="vw8jteex4mgc">
          <Route path="/" element={<HomePage data-id="element-43" data-mp="vvgpe6x24urn" />} data-id="element-42" data-mp="vwruqb65iakv" />
          <Route path="/services" element={<Navigate to="/ai-lead-conversion" replace data-id="element-45" data-mp="3kob38cimu048" />} data-id="element-44" data-mp="vvyrvlabc580" />
          <Route path="/ai-lead-conversion" element={<AutomationsPage data-id="element-47" data-mp="3glel0mx0860t" />} data-id="element-46" data-mp="3gmh80jr7hobg" />
          <Route path="/automations" element={<Navigate to="/ai-lead-conversion" replace data-id="element-49" data-mp="1w5gfiva8i46d" />} data-id="element-48" data-mp="3gok6ztac6rsb" />
          <Route path="/custom-automations" element={<CustomAutomationsPage data-id="element-51" data-mp="203xn1fxkhgob" />} data-id="element-50" data-mp="205qv8zntw8yf" />
          <Route path="/crm-business-tools" element={<CrmBusinessToolsPage data-id="element-53" data-mp="253a7ju0yubnq" />} data-id="element-52" data-mp="254v3no2xi2np" />
          <Route path="/reputation-management" element={<ReputationManagementPage data-id="element-55" data-mp="2ev6hq3gbts8b" />} data-id="element-54" data-mp="29wv7vsq17hq3" />
          <Route path="/ad-campaigns" element={<AdCampaignsPage data-id="element-57" data-mp="2jtzlv59q46vt" />} data-id="element-56" data-mp="2eueqt5xociod" />
          <Route path="/web-design-seo" element={<WebDesignSeoPage data-id="element-59" data-mp="2js6hjwml1yqz" />} data-id="element-58" data-mp="2jsyat0spjke3" />
          <Route path="/google-business-profile-setup" element={<GbpSetupPage data-id="element-61" data-mp="2ntrzhwdz5381" />} data-id="element-60" data-mp="2nvunybzhaoan" />
          <Route path="/tools/gmail-signature-generator" element={<GmailSignatureGeneratorPage data-id="element-63" data-mp="thtnjmoa5t8g" />} data-id="element-62" data-mp="2suxslvbjqsi3" />
          <Route path="/pricing" element={<PricingPage data-id="element-65" data-mp="ygoh9jnsd27c" />} data-id="element-64" data-mp="tj4vlyordn5d" />
          <Route path="/about" element={<AboutPage data-id="element-67" data-mp="yh6mh5sfeqre" />} data-id="element-66" data-mp="yfv7e9tj5wkz" />
          <Route path="/case-studies/tfp-landscaping" element={<TfpLandscapingPage data-id="element-69" data-mp="21s3wz2qf0om3" />} data-id="element-68" data-mp="yir825wrizd4" />
          <Route path="/case-studies/finish-coat-painting" element={<FinishCoatPaintingPage data-id="element-71" data-mp="1wuu2h8o65mre" />} data-id="element-70" data-mp="1wsqzzp5ty15s" />
          <Route path="/case-studies" element={<CaseStudiesPage data-id="element-73" data-mp="2aq5tp6348v3k" />} data-id="element-72" data-mp="2atbiek7u1uyr" />
          <Route path="/blog" element={<BlogPage data-id="element-75" data-mp="25s4a8k1s2trk" />} data-id="element-74" data-mp="25tfesm31s5jq" />
          <Route path="/blog/how-to-choose-marketing-agency" element={<HowToChooseMarketingAgency data-id="element-77" data-mp="2kp54au7fz0t7" />} data-id="element-76" data-mp="25rujuvctmklc" />
          <Route path="/blog/why-response-time-makes-or-breaks-your-yelp-ads" element={<WhyResponseTimeMakesOrBreaksYourYelpAds data-id="element-79" data-mp="2tii8isayhoul" />} data-id="element-78" data-mp="2frlfx1h157nj" />
          <Route path="/blog/faster-yelp-replies-more-landscaping-estimates" element={<FasterYelpRepliesMoreLandscapingEstimates data-id="element-81" data-mp="2pj9ernfx1qz1" />} data-id="element-80" data-mp="2tkum6t9old1u" />
          <Route path="/blog/ai-receptionist-vs-human-receptionist-cost" element={<AiReceptionistVsHumanReceptionistCost data-id="element-83" data-mp="2yiw4hbza98c9" />} data-id="element-82" data-mp="33hpkbb21lbfl" />
          <Route path="/blog/missed-call-text-back-phoenix-home-services" element={<MissedCallTextBack data-id="element-85" data-mp="3n2fzroyfb7t8" />} data-id="element-84" data-mp="3i3wcnl83fpza" />
          {/* Legacy /f/ blog URLs -- redirect old indexed links to the new in-app posts */}
          <Route path="/f/why-response-time-makes-or-breaks-your-yelp-ads" element={<Navigate to="/blog/why-response-time-makes-or-breaks-your-yelp-ads" replace data-id="element-87" data-mp="3d2yuh8n32vxs" />} data-id="element-86" data-mp="384nlt18iyrh5" />
          <Route path="/f/faster-yelp-replies-more-landscaping-estimates" element={<Navigate to="/blog/faster-yelp-replies-more-landscaping-estimates" replace data-id="element-89" data-mp="2pfqtv40lob23" />} data-id="element-88" data-mp="344djbyjxyj71" />
          <Route path="/contact" element={<ContactPage data-id="element-91" data-mp="2ge0zbpbf8w03" />} data-id="element-90" data-mp="2ge9drln709de" />
          <Route path="/privacy" element={<PrivacyPolicyPage data-id="element-93" data-mp="2ggn8ftdynjkf" />} data-id="element-92" data-mp="2gesxn7wel7u2" />
          <Route path="/terms" element={<TermsOfServicePage data-id="element-95" data-mp="2kfct871bw3e3" />} data-id="element-94" data-mp="2kg4dilph6ep2" />
        </Routes>
      </main>
      <Footer data-id="element-96" data-mp="30vx17o19hjhk" />
    </div>;
}
export function App() {
  useEffect(() => {
    // Google Analytics (gtag.js)
    const GA_MEASUREMENT_ID = 'G-C4JZKB2BFQ';
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(gtagScript);
    const gtagInit = document.createElement('script');
    gtagInit.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_MEASUREMENT_ID}');
    `;
    document.head.appendChild(gtagInit);
    // Meta Pixel
    const fbScript = document.createElement('script');
    fbScript.text = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '970566142171718');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(fbScript);
    const fbNoscript = document.createElement('noscript');
    const fbImg = document.createElement('img');
    fbImg.height = 1;
    fbImg.width = 1;
    fbImg.style.display = 'none';
    fbImg.src = 'https://www.facebook.com/tr?id=970566142171718&ev=PageView&noscript=1';
    fbNoscript.appendChild(fbImg);
    document.body.appendChild(fbNoscript);
    // GHL Chat Widget
    const chatDiv = document.createElement('div');
    chatDiv.setAttribute('data-chat-widget', '');
    chatDiv.setAttribute('data-widget-id', '69ced0ba10e73a6e4e745753');
    chatDiv.setAttribute('data-location-id', 'JLycxFbUVQFY3z4zPpCS');
    document.body.appendChild(chatDiv);
    const script = document.createElement('script');
    script.src = 'https://widgets.leadconnectorhq.com/loader.js';
    script.setAttribute('data-resources-url', 'https://widgets.leadconnectorhq.com/chat-widget/loader.js');
    script.setAttribute('data-widget-id', '69ced0ba10e73a6e4e745753');
    document.body.appendChild(script);
    return () => {
      if (gtagScript.parentNode) gtagScript.parentNode.removeChild(gtagScript);
      if (gtagInit.parentNode) gtagInit.parentNode.removeChild(gtagInit);
      if (fbScript.parentNode) fbScript.parentNode.removeChild(fbScript);
      if (fbNoscript.parentNode) fbNoscript.parentNode.removeChild(fbNoscript);
      if (chatDiv.parentNode) chatDiv.parentNode.removeChild(chatDiv);
      if (script.parentNode) script.parentNode.removeChild(script);
    };
  }, []);
  return <BrowserRouter data-id="element-97" data-mp="1dqnwwn5gmkw8">
      <ScrollToTop data-id="element-98" data-mp="1dp34b32phc10" />
      <Routes data-id="element-99" data-mp="1dpmjic0z1mbc">
        <Route path="/robots.txt" element={<RobotsTxt data-id="element-101" data-mp="1ioz4er8a8jba" />} data-id="element-100" data-mp="1do1s2v9yejhp" />
        <Route path="/sitemap.xml" element={<SitemapXml data-id="element-103" data-mp="1in4l1hcnsz9b" />} data-id="element-102" data-mp="1io7cbqdw93pr" />
        <Route path="/*" element={<SiteLayout data-id="element-105" data-mp="3vzs8rp4lq6u3" />} data-id="element-104" data-mp="3vzievqgfrfj4" />
      </Routes>
    </BrowserRouter>;
}